import { isSlowDeviceUtil } from '../../../utils/device/is-slow'

export const MEDIA_LAYOUT_TYPE = {
  CARD: 'card',
  CARD_TALL: 'cardTall',
  ROW: 'row',
  ROW_VERTICAL: 'rowVertical',
  SMALL: 'small',
  SMALL_WIDE: 'smallWide',
  SMALL_VERTICAL: 'smallVertical',
  BACKGROUND: 'background',
  LARGE: 'large',
  VERTICAL: 'vertical'
}

export const MEDIA_RESIZE_MODE = {
  COVER: 'cover',
  CONTAIN: 'contain'
}

export const MEDIA_LAYOUT_TYPE_TO_FILE_SUFFIX = {
  [MEDIA_LAYOUT_TYPE.CARD]: isSlowDeviceUtil()
    ? 'small'
    : 'medium',
  [MEDIA_LAYOUT_TYPE.CARD_TALL]: isSlowDeviceUtil()
    ? 'small'
    : 'medium',
  [MEDIA_LAYOUT_TYPE.ROW]: isSlowDeviceUtil()
    ? 'small'
    : 'medium',
  [MEDIA_LAYOUT_TYPE.ROW_VERTICAL]: isSlowDeviceUtil()
    ? 'small'
    : 'medium',
  [MEDIA_LAYOUT_TYPE.SMALL]: isSlowDeviceUtil()
    ? 'small'
    : 'medium',
  [MEDIA_LAYOUT_TYPE.SMALL_WIDE]: isSlowDeviceUtil()
    ? 'medium'
    : 'large',
  [MEDIA_LAYOUT_TYPE.VERTICAL]: isSlowDeviceUtil()
    ? 'medium'
    : 'large',
  [MEDIA_LAYOUT_TYPE.SMALL_VERTICAL]: isSlowDeviceUtil()
    ? 'medium'
    : 'large',
  [MEDIA_LAYOUT_TYPE.BACKGROUND]: isSlowDeviceUtil()
    ? 'medium'
    : 'large',
  [MEDIA_LAYOUT_TYPE.LARGE]: isSlowDeviceUtil()
    ? 'medium'
    : 'large'
}
